import { Button, cn } from '@desoutter/uikit'
import { RedcardsBlockFragment } from './RedcardsBlock.generated'
import DatoLink from '@/components/DatoLink/DatoLink'

type RedcardsBlockProps = {
	fragment: RedcardsBlockFragment
}

export default function RedcardsBlock({ fragment }: RedcardsBlockProps) {
	return (
		<div
			id={fragment.anchor ? 'spy_' + fragment.anchor.replaceAll(' ', '_') : ''}
			className={fragment.isDark ? 'dark' : ''}
		>
			<div className="bg-background text-foreground">
				<div className="container-auto">
					<div
						className={cn(
							'flex flex-col items-center w-full py-16',
							fragment.isLeftVariant ? 'items-start' : 'items-center',
						)}
					>
						<div
							className={cn(
								'rounded-3xl bg-primary text-primary-foreground',
								fragment.isLeftVariant
									? 'flex flex-col gap-6 w-full p-12 xl:w-1/2'
									: 'max-w-[800px] p-8 ',
							)}
						>
							{fragment.title ? (
								<h2
									className={cn(
										'h4 markdown',
										!fragment.isLeftVariant && 'text-center',
									)}
									dangerouslySetInnerHTML={{ __html: fragment.title }}
								/>
							) : null}
							<div
								className={cn(
									'h5 markdown',
									!fragment.isLeftVariant && 'text-center',
								)}
								dangerouslySetInnerHTML={{ __html: fragment.text }}
							/>
							<div
								className={cn(
									'sm:flex gap-6',
									!fragment.isLeftVariant && 'justify-center',
								)}
							>
								{fragment.buttons.map((button, i) => (
									<DatoLink
										key={i}
										fragment={button}
										className={button.classParam}
									>
										<Button
											color={i % 2 ? 'secondary' : 'tertiary'}
											className="mt-6"
											title={button.label}
										>
											{button.label}
										</Button>
									</DatoLink>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
